import _delay from 'lodash/delay';
import {
  CLOSE_DIALOG,
  REFRESH_LIST,
  HIDE_LOADING,
} from '../constants/ActionTypes';
import { flushDialog, refreshListReinit, hideLoadingReinit } from '../actions';

const actionsChaining = (store) => (next) => (action) => {
  next(action);

  switch (action.type) {
    case CLOSE_DIALOG:
      // Flush the concerned Dialog after a short delay
      _delay(() => store.dispatch(flushDialog(action.componentType)), 500);
      break;
    case REFRESH_LIST:
      // Reinit the refresh status after a short delay
      _delay(() => store.dispatch(refreshListReinit()), 200);
      break;
    case HIDE_LOADING:
      // Reinit the force hide value after a short delay
      _delay(() => store.dispatch(hideLoadingReinit()), 200);
      break;
    default:
      break;
  }
};

export default actionsChaining;



// WEBPACK FOOTER //
// ./middlewares/actionsChaining.js